export const translations = {
  fr: {
    nav: {
      brand: "Cap Malaisie",
      cta: "Trouver mon visa",
      visas: "Les visas",
      benefits: "Pourquoi la Malaisie",
      faq: "FAQ",
      ariaLangSelector: "Sélecteur de langue",
      menu: "Menu",
    },
    hero: {
      badge: "Le guide d'immigration pour les Français",
      title: "Votre nouvelle vie commence en Malaisie",
      subtitle:
        "Pays musulman moderne et ouvert, voisin de Singapour sans en partager les coûts. Découvrez le visa fait pour vous en 3 minutes.",
      ctaPrimary: "Trouver mon visa",
      ctaSecondary: "Voir les visas",
      trust: "Gratuit · 3 minutes · Résultat personnalisé",
      statCost: "~3x",
      statCostLabel: "moins cher que Singapour",
      statFlight: "1h",
      statFlightLabel: "de vol de Singapour",
      statFrench: "5 000+",
      statFrenchLabel: "Français déjà installés",
      statHalal: "100%",
      statHalalLabel: "halal-friendly au quotidien",
      imageAlt: "Skyline de Kuala Lumpur au coucher du soleil",
    },
    benefits: {
      heading: "Pourquoi la Malaisie ?",
      sub: "Un pays musulman, moderne et accueillant, au cœur de l'Asie du Sud-Est — sans les prix de Singapour.",
      items: {
        muslim: {
          title: "Pays musulman & halal au quotidien",
          desc: "L'islam est religion officielle : nourriture halal partout, mosquées dans chaque quartier, atmosphère respectueuse de la pratique religieuse.",
        },
        open: {
          title: "Société ouverte et multiculturelle",
          desc: "Malais, Chinois, Indiens et expatriés vivent ensemble. Une tolérance et une ouverture rares dans la région.",
        },
        english: {
          title: "Anglais largement parlé",
          desc: "L'anglais est utilisé partout : administration, commerces, santé. Pas besoin de parler malais pour s'installer.",
        },
        singapore: {
          title: "Voisin de Singapour, sans les coûts",
          desc: "À 1h de vol (ou 45 min de Johor Bahru) de Singapour, avec un coût de la vie environ 3 fois inférieur. Profitez du dynamisme de la région sans les loyers singapouriens.",
          badge: "Le meilleur des deux mondes",
        },
        cost: {
          title: "Coût de la vie attractif",
          desc: "Loyers jusqu'à 70% moins chers qu'à Paris, repas au restaurant dès 2-3 €, aide à domicile abordable.",
        },
        tax: {
          title: "Fiscalité avantageuse",
          desc: "Imposition territoriale : les revenus de source étrangère sont généralement non imposés (selon votre situation).",
        },
        health: {
          title: "Santé de niveau international",
          desc: "Hôpitaux privés réputés dans toute l'Asie, médecins anglophones, tarifs bien inférieurs à l'Europe.",
        },
        education: {
          title: "Éducation internationale",
          desc: "Écoles internationales abordables et un Lycée Français à Kuala Lumpur pour la scolarité de vos enfants.",
        },
        travel: {
          title: "Hub de voyage tropical",
          desc: "Climat tropical toute l'année, plages et jungles, vols low-cost vers toute l'Asie depuis KL.",
        },
        community: {
          title: "Communauté française active",
          desc: "Des milliers de Français installés, associations, événements et réseaux d'entraide francophones.",
        },
      },
    },
    visasSection: {
      heading: "Les 6 visas principaux",
      sub: "Chaque profil a sa porte d'entrée. Le quiz vous indique la vôtre.",
      forWho: "Pour qui",
      duration: "Durée",
      cta: "Ce visa est-il pour moi ?",
    },
    howItWorks: {
      heading: "Comment ça marche ?",
      steps: [
        {
          title: "Répondez à 8 questions",
          desc: "Âge, situation, revenus, projet : 3 minutes suffisent.",
        },
        {
          title: "On calcule votre meilleur visa",
          desc: "Notre algorithme compare votre profil aux critères des 6 visas.",
        },
        {
          title: "Recevez votre résultat",
          desc: "Laissez votre email et découvrez votre visa recommandé + les alternatives.",
        },
      ],
      cta: "Commencer le quiz",
    },
    faq: {
      heading: "Questions fréquentes",
      sub: "Coûts, religion, sécurité, écoles : les réponses aux questions que se posent les Français avant de partir.",
      items: [
        {
          category: "Coûts",
          question: "Quel budget mensuel prévoir pour vivre en Malaisie ?",
          answer:
            "Une personne seule vit confortablement à Kuala Lumpur avec 1 200 à 1 800 € par mois, loyer inclus. Comptez 2 500 à 3 500 € pour une famille. Un appartement moderne avec piscine et salle de sport dans un quartier central de KL coûte entre 400 et 800 €/mois — jusqu'à 70% moins cher qu'à Paris.",
        },
        {
          category: "Coûts",
          question: "La Malaisie est-elle vraiment moins chère que Singapour ?",
          answer:
            "Oui, environ 3 fois moins chère. Un repas complet coûte 2-3 € contre 12-15 € à Singapour, un loyer équivalent est 3 à 4 fois inférieur, et les services (taxi, ménage, garde d'enfants) restent très abordables. Vous profitez du dynamisme économique de la région — Singapour est à 1h de vol ou 45 min de Johor Bahru — sans en payer le prix.",
        },
        {
          category: "Religion",
          question: "Comment se passe la pratique de l'islam au quotidien ?",
          answer:
            "L'islam est la religion officielle de la Malaisie : mosquées dans chaque quartier, nourriture halal par défaut dans la grande majorité des restaurants et supermarchés, salles de prière dans les centres commerciaux, aéroports et bureaux. Le Ramadan et les fêtes musulmanes rythment la vie du pays. C'est l'un des pays les plus faciles au monde pour un musulman pratiquant.",
        },
        {
          category: "Religion",
          question: "Et si je ne suis pas musulman·e ?",
          answer:
            "Aucun problème : la liberté de culte est garantie par la Constitution. Environ 40% de la population est non musulmane (bouddhistes, chrétiens, hindous). Églises, temples et lieux de culte sont présents partout, l'alcool est disponible dans les restaurants et supermarchés non halal, et le mode de vie occidental est parfaitement accepté.",
        },
        {
          category: "Sécurité",
          question: "La Malaisie est-elle un pays sûr ?",
          answer:
            "Oui, c'est l'un des pays les plus sûrs d'Asie du Sud-Est. La criminalité violente est rare et la Malaisie figure régulièrement dans le top 20 du Global Peace Index — devant la France. Comme partout, restez vigilant face aux petits vols dans les zones touristiques. Les quartiers résidentiels sont majoritairement sécurisés avec gardiennage 24h/24.",
        },
        {
          category: "Écoles",
          question: "Quelles options scolaires pour mes enfants ?",
          answer:
            "Le Lycée Français de Kuala Lumpur (homologué AEFE) accueille les élèves de la maternelle à la terminale, avec le programme français officiel. Vous trouverez aussi de nombreuses écoles internationales (britanniques, américaines, IB) entre 5 000 et 25 000 €/an — bien moins chères qu'à Singapour ou Dubaï.",
        },
        {
          category: "Écoles",
          question: "Et pour les études supérieures ?",
          answer:
            "La Malaisie héberge des campus délocalisés d'universités réputées (Nottingham, Monash, Heriot-Watt...) avec des frais de scolarité 2 à 3 fois inférieurs aux campus d'origine. Les cursus sont en anglais et les diplômes identiques. C'est aussi la voie du Student Pass pour s'installer dans le pays.",
        },
      ],
    },

    newsletter: {
      heading: "Restez informé·e",
      sub: "Recevez nos guides pratiques et les actualités visa Malaisie. Pas de spam, promis.",
      placeholder: "Votre adresse email",
      button: "S'inscrire",
      success: "Merci ! Vous êtes bien inscrit·e.",
      duplicate: "Vous êtes déjà inscrit·e — merci !",
      invalid: "Veuillez saisir une adresse email valide.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      consent: "En vous inscrivant, vous acceptez de recevoir nos emails. Désinscription en 1 clic.",
    },
    footer: {
      disclaimer:
        "Les informations fournies sur ce site sont à titre indicatif et ne constituent pas un conseil juridique. Vérifiez toujours les exigences officielles auprès des autorités malaisiennes (Immigration Malaysia, MM2H Centre, MDEC).",
      rights: "Tous droits réservés.",
    },
    quiz: {
      title: "Trouvez votre visa",
      stepOf: (current, total) => `Question ${current} sur ${total}`,
      back: "Retour",
      next: "Suivant",
      seeResult: "Voir mon résultat",
      questions: {
        age: {
          label: "Quel est votre âge ?",
          options: {
            under_25: "Moins de 25 ans",
            "25_34": "25 – 34 ans",
            "35_49": "35 – 49 ans",
            "50_plus": "50 ans et plus",
          },
        },
        work_status: {
          label: "Quelle est votre situation professionnelle ?",
          options: {
            remote_employee: "Salarié·e en télétravail pour une entreprise étrangère",
            job_offer: "J'ai une offre d'emploi en Malaisie",
            entrepreneur: "Entrepreneur·e / investisseur·euse",
            student: "Étudiant·e ou futur·e étudiant·e",
            retired: "Retraité·e",
            searching: "En recherche d'opportunités",
          },
        },
        income: {
          label: "Quels sont vos revenus mensuels ?",
          options: {
            under_1500: "Moins de 1 500 €",
            "1500_3000": "1 500 – 3 000 €",
            "3000_5000": "3 000 – 5 000 €",
            over_5000: "Plus de 5 000 €",
          },
        },
        purpose: {
          label: "Quel est votre objectif principal en Malaisie ?",
          options: {
            work: "Travailler pour une entreprise locale",
            remote_lifestyle: "Vivre en télétravail (nomade digital)",
            study: "Étudier",
            retire: "Prendre ma retraite au soleil",
            business: "Créer ou développer une entreprise",
            family: "Rejoindre mon conjoint / ma famille",
          },
        },
        duration: {
          label: "Combien de temps souhaitez-vous rester ?",
          options: {
            under_1y: "Moins d'un an",
            "1_2y": "1 – 2 ans",
            "2_5y": "2 – 5 ans",
            long_term: "Long terme / définitivement",
          },
        },
        married_malaysian: {
          label: "Êtes-vous marié·e à un·e citoyen·ne malaisien·ne ?",
          options: {
            yes: "Oui",
            no: "Non",
          },
        },
        savings: {
          label: "Quelle est votre capacité d'épargne ou d'investissement ?",
          options: {
            under_10k: "Moins de 10 000 €",
            "10k_50k": "10 000 – 50 000 €",
            "50k_150k": "50 000 – 150 000 €",
            over_150k: "Plus de 150 000 €",
          },
        },
        family: {
          label: "Avec qui partez-vous ?",
          options: {
            alone: "Seul·e",
            couple: "En couple",
            with_children: "Avec enfants",
          },
        },
      },
      emailGate: {
        title: "Votre résultat est prêt !",
        sub: "Entrez votre email pour découvrir le visa fait pour vous et recevoir votre checklist d'immigration.",
        placeholder: "Votre adresse email",
        button: "Découvrir mon visa",
        consent: "Pas de spam. Vos données restent confidentielles.",
        invalid: "Veuillez saisir une adresse email valide.",
        error: "Une erreur est survenue. Veuillez réessayer.",
      },
      result: {
        heading: "Votre visa recommandé",
        match: "de compatibilité",
        requirements: "Conditions principales",
        pros: "Points forts",
        alternatives: "Alternatives à considérer",
        restart: "Refaire le quiz",
        home: "Retour à l'accueil",
        emailSaved: "Résultat envoyé ! Vérifiez votre boîte mail prochainement.",
        disclaimerShort:
          "Résultat indicatif — vérifiez les critères officiels avant toute démarche.",
      },
      loading: "Calcul de votre visa idéal...",
      submitError: "Impossible de calculer votre résultat. Veuillez réessayer.",
      retry: "Réessayer",
    },
    visas: {
      mm2h: {
        name: "MM2H",
        fullName: "Malaysia My Second Home",
        tagline: "La résidence longue durée pour retraités et patrimoines confortables",
        forWho: "Retraités, indépendants financièrement, familles cherchant le long terme",
        duration: "5 à 20 ans, renouvelable",
        requirements: [
          "Dépôt bancaire à partir de ~150 000 USD (niveau Silver)",
          "Preuve de ressources financières stables",
          "Assurance santé valable en Malaisie",
          "Casier judiciaire vierge",
        ],
        pros: [
          "Résidence stable de 5 à 20 ans",
          "Conjoint et enfants inclus",
          "Multiples entrées illimitées",
        ],
      },
      de_rantau: {
        name: "DE Rantau",
        fullName: "DE Rantau Nomad Pass",
        tagline: "Le visa nomade digital officiel de la Malaisie",
        forWho: "Télétravailleurs, freelances et nomades digitaux avec revenus étrangers",
        duration: "12 mois, renouvelable 12 mois",
        requirements: [
          "Revenus à distance d'au moins ~24 000 USD/an",
          "Contrat de travail à distance ou clients étrangers",
          "Passeport valide + assurance santé",
        ],
        pros: [
          "Procédure 100% en ligne via MDEC",
          "Conjoint et enfants peuvent accompagner",
          "Accès aux hubs DE Rantau dans tout le pays",
        ],
      },
      employment_pass: {
        name: "Employment Pass",
        fullName: "Employment Pass (EP)",
        tagline: "Le visa de travail classique sponsorisé par un employeur",
        forWho: "Professionnels avec une offre d'emploi d'une entreprise malaisienne",
        duration: "1 à 5 ans selon la catégorie",
        requirements: [
          "Offre d'emploi d'une société enregistrée en Malaisie",
          "Salaire minimum ~5 000 RM/mois (cat. III) à 10 000 RM (cat. I)",
          "Diplômes et expérience pertinents",
        ],
        pros: [
          "Sponsorisé par l'employeur",
          "Renouvelable tant que vous êtes employé",
          "Possibilité de visa pour la famille (Dependant Pass)",
        ],
      },
      student_pass: {
        name: "Student Pass",
        fullName: "Student Pass",
        tagline: "Étudier dans les universités internationales malaisiennes",
        forWho: "Étudiants inscrits dans une institution reconnue en Malaisie",
        duration: "Durée des études",
        requirements: [
          "Lettre d'admission d'une institution reconnue",
          "Preuve de moyens financiers pour études + séjour",
          "Visa demandé via EMGS avant l'arrivée",
        ],
        pros: [
          "Frais de scolarité très compétitifs",
          "Campus de universités britanniques et australiennes",
          "Travail à temps partiel possible (conditions)",
        ],
      },
      labuan_investor: {
        name: "Visa Investisseur / Labuan",
        fullName: "Labuan Director Visa / Investor",
        tagline: "Créez votre société et obtenez un visa de 2 ans",
        forWho: "Entrepreneurs et investisseurs créant une activité en Malaisie",
        duration: "2 ans, renouvelable",
        requirements: [
          "Création d'une société Labuan (capital libéré requis)",
          "Fonction de directeur dans la société",
          "Capacité financière à investir et maintenir l'activité",
        ],
        pros: [
          "Fiscalité Labuan attractive (3% ou forfait)",
          "Visa pour conjoint et enfants",
          "Grande liberté d'activité internationale",
        ],
      },
      spouse_ltsvp: {
        name: "Visa Conjoint",
        fullName: "Long-Term Social Visit Pass (conjoint)",
        tagline: "Pour les conjoints de citoyens malaisiens",
        forWho: "Personnes mariées à un·e citoyen·ne malaisien·ne",
        duration: "Jusqu'à 5 ans, renouvelable",
        requirements: [
          "Certificat de mariage reconnu en Malaisie",
          "Sponsor : votre conjoint·e malaisien·ne",
          "Preuves de vie commune authentique",
        ],
        pros: [
          "Autorisation de travail possible (endorsement)",
          "Voie vers la résidence permanente",
          "Renouvellements de plus en plus longs",
        ],
      },
    },
    admin: {
      title: "Tableau de bord — Leads",
      sub: "Emails collectés via le quiz et la newsletter",
      loginTitle: "Espace administrateur",
      loginSub: "Entrez le mot de passe pour accéder aux leads collectés.",
      passwordPlaceholder: "Mot de passe",
      loginButton: "Se connecter",
      loginError: "Mot de passe incorrect.",
      loginNetworkError: "Connexion impossible. Réessayez.",
      logout: "Se déconnecter",
      sessionExpired: "Session expirée. Veuillez vous reconnecter.",
      totalLeads: "Total leads",
      last7: "7 derniers jours",
      topVisa: "Visa le plus recommandé",
      quizLeads: "Via quiz",
      newsletterLeads: "Via newsletter",
      export: "Exporter CSV",
      exportSuccess: "Export CSV téléchargé.",
      exportError: "Échec de l'export. Réessayez.",
      colEmail: "Email",
      colDate: "Date",
      colSource: "Source",
      colVisa: "Visa recommandé",
      colLang: "Langue",
      empty: "Aucun lead pour le moment. Partagez votre page !",
      loading: "Chargement des leads...",
      error: "Impossible de charger les leads.",
      retry: "Réessayer",
      sourceQuiz: "Quiz",
      sourceNewsletter: "Newsletter",
      none: "—",
    },
    notFound: {
      message: "Cette page n'existe pas ou a été déplacée.",
      backHome: "Retour à l'accueil",
    },
    cookieConsent: {
      message: "Ce site utilise des cookies pour améliorer votre expérience et analyser le trafic. Vous pouvez accepter ou refuser.",
      accept: "Accepter",
      decline: "Refuser",
      ariaLabel: "Bandeau de consentement aux cookies",
    },
  },

  en: {
    nav: {
      brand: "Cap Malaisie",
      cta: "Find my visa",
      visas: "Visas",
      benefits: "Why Malaysia",
      faq: "FAQ",
      ariaLangSelector: "Language selector",
      menu: "Menu",
    },
    hero: {
      badge: "The immigration guide for French citizens",
      title: "Your new life starts in Malaysia",
      subtitle:
        "A modern, open Muslim country — Singapore's neighbor without Singapore's costs. Find the right visa for you in 3 minutes.",
      ctaPrimary: "Find my visa",
      ctaSecondary: "See the visas",
      trust: "Free · 3 minutes · Personalized result",
      statCost: "~3x",
      statCostLabel: "cheaper than Singapore",
      statFlight: "1h",
      statFlightLabel: "flight from Singapore",
      statFrench: "5,000+",
      statFrenchLabel: "French already settled",
      statHalal: "100%",
      statHalalLabel: "halal-friendly daily life",
      imageAlt: "Kuala Lumpur skyline at sunset",
    },
    benefits: {
      heading: "Why Malaysia?",
      sub: "A modern, welcoming Muslim country in the heart of Southeast Asia — without Singapore prices.",
      items: {
        muslim: {
          title: "Muslim country & halal everyday life",
          desc: "Islam is the official religion: halal food everywhere, mosques in every neighborhood, and a respectful atmosphere for religious practice.",
        },
        open: {
          title: "Open, multicultural society",
          desc: "Malays, Chinese, Indians and expats live side by side. A rare level of tolerance and openness in the region.",
        },
        english: {
          title: "English widely spoken",
          desc: "English is used everywhere: administration, shops, healthcare. No need to speak Malay to settle in.",
        },
        singapore: {
          title: "Singapore's neighbor, without the costs",
          desc: "1 hour by plane (or 45 min from Johor Bahru) from Singapore, with a cost of living roughly 3 times lower. Enjoy the region's energy without Singaporean rents.",
          badge: "Best of both worlds",
        },
        cost: {
          title: "Attractive cost of living",
          desc: "Rents up to 70% cheaper than Paris, restaurant meals from €2-3, affordable home help.",
        },
        tax: {
          title: "Favorable taxation",
          desc: "Territorial tax system: foreign-sourced income is generally not taxed (depending on your situation).",
        },
        health: {
          title: "International-grade healthcare",
          desc: "Private hospitals renowned across Asia, English-speaking doctors, prices far below Europe.",
        },
        education: {
          title: "International education",
          desc: "Affordable international schools and a French Lycée in Kuala Lumpur for your children's schooling.",
        },
        travel: {
          title: "Tropical travel hub",
          desc: "Tropical climate year-round, beaches and jungles, low-cost flights across Asia from KL.",
        },
        community: {
          title: "Active French community",
          desc: "Thousands of French residents, associations, events and francophone support networks.",
        },
      },
    },
    visasSection: {
      heading: "The 6 main visas",
      sub: "Every profile has its own way in. The quiz shows you yours.",
      forWho: "Who it's for",
      duration: "Duration",
      cta: "Is this visa for me?",
    },
    howItWorks: {
      heading: "How it works",
      steps: [
        {
          title: "Answer 8 questions",
          desc: "Age, situation, income, project: 3 minutes is enough.",
        },
        {
          title: "We compute your best visa",
          desc: "Our algorithm compares your profile against the 6 visa criteria.",
        },
        {
          title: "Get your result",
          desc: "Leave your email to see your recommended visa + alternatives.",
        },
      ],
      cta: "Start the quiz",
    },
    faq: {
      heading: "Frequently asked questions",
      sub: "Costs, religion, safety, schools: answers to the questions French people ask before moving.",
      items: [
        {
          category: "Costs",
          question: "What monthly budget do I need to live in Malaysia?",
          answer:
            "A single person lives comfortably in Kuala Lumpur on €1,200 to €1,800 per month, rent included. Plan €2,500 to €3,500 for a family. A modern apartment with pool and gym in a central KL neighborhood costs €400-800/month — up to 70% cheaper than Paris.",
        },
        {
          category: "Costs",
          question: "Is Malaysia really cheaper than Singapore?",
          answer:
            "Yes, roughly 3 times cheaper. A full meal costs €2-3 versus €12-15 in Singapore, an equivalent rent is 3 to 4 times lower, and services (taxi, cleaning, childcare) remain very affordable. You enjoy the region's economic energy — Singapore is 1 hour by plane or 45 minutes from Johor Bahru — without paying its price.",
        },
        {
          category: "Religion",
          question: "What is daily life like for practicing Muslims?",
          answer:
            "Islam is Malaysia's official religion: mosques in every neighborhood, halal food by default in the vast majority of restaurants and supermarkets, prayer rooms in malls, airports and offices. Ramadan and Muslim holidays shape the country's rhythm. It is one of the easiest countries in the world for a practicing Muslim.",
        },
        {
          category: "Religion",
          question: "What if I am not Muslim?",
          answer:
            "No problem: freedom of worship is guaranteed by the Constitution. About 40% of the population is non-Muslim (Buddhists, Christians, Hindus). Churches, temples and places of worship are everywhere, alcohol is available in non-halal restaurants and supermarkets, and Western lifestyles are fully accepted.",
        },
        {
          category: "Safety",
          question: "Is Malaysia a safe country?",
          answer:
            "Yes, it is one of the safest countries in Southeast Asia. Violent crime is rare and Malaysia regularly ranks in the top 20 of the Global Peace Index — ahead of France. As anywhere, stay alert to petty theft in tourist areas. Residential neighborhoods are mostly gated with 24/7 security.",
        },
        {
          category: "Schools",
          question: "What schooling options are there for my children?",
          answer:
            "The Lycée Français de Kuala Lumpur (AEFE-accredited) welcomes pupils from kindergarten to the baccalaureate, following the official French curriculum. You will also find many international schools (British, American, IB) between €5,000 and €25,000/year — far cheaper than Singapore or Dubai.",
        },
        {
          category: "Schools",
          question: "What about higher education?",
          answer:
            "Malaysia hosts branch campuses of renowned universities (Nottingham, Monash, Heriot-Watt...) with tuition fees 2 to 3 times lower than the home campuses. Courses are in English and degrees are identical. It is also the Student Pass route to settle in the country.",
        },
      ],
    },

    newsletter: {
      heading: "Stay informed",
      sub: "Get our practical guides and Malaysia visa news. No spam, promise.",
      placeholder: "Your email address",
      button: "Subscribe",
      success: "Thank you! You are subscribed.",
      duplicate: "You're already subscribed — thank you!",
      invalid: "Please enter a valid email address.",
      error: "Something went wrong. Please try again.",
      consent: "By subscribing you agree to receive our emails. Unsubscribe anytime.",
    },
    footer: {
      disclaimer:
        "The information on this site is for guidance only and does not constitute legal advice. Always verify official requirements with Malaysian authorities (Immigration Malaysia, MM2H Centre, MDEC).",
      rights: "All rights reserved.",
    },
    quiz: {
      title: "Find your visa",
      stepOf: (current, total) => `Question ${current} of ${total}`,
      back: "Back",
      next: "Next",
      seeResult: "See my result",
      questions: {
        age: {
          label: "How old are you?",
          options: {
            under_25: "Under 25",
            "25_34": "25 – 34",
            "35_49": "35 – 49",
            "50_plus": "50 and above",
          },
        },
        work_status: {
          label: "What is your professional situation?",
          options: {
            remote_employee: "Remote employee for a foreign company",
            job_offer: "I have a job offer in Malaysia",
            entrepreneur: "Entrepreneur / investor",
            student: "Student or future student",
            retired: "Retired",
            searching: "Looking for opportunities",
          },
        },
        income: {
          label: "What is your monthly income?",
          options: {
            under_1500: "Under €1,500",
            "1500_3000": "€1,500 – €3,000",
            "3000_5000": "€3,000 – €5,000",
            over_5000: "Over €5,000",
          },
        },
        purpose: {
          label: "What is your main goal in Malaysia?",
          options: {
            work: "Work for a local company",
            remote_lifestyle: "Live as a digital nomad",
            study: "Study",
            retire: "Retire in the sun",
            business: "Start or grow a business",
            family: "Join my spouse / family",
          },
        },
        duration: {
          label: "How long do you plan to stay?",
          options: {
            under_1y: "Less than a year",
            "1_2y": "1 – 2 years",
            "2_5y": "2 – 5 years",
            long_term: "Long term / permanently",
          },
        },
        married_malaysian: {
          label: "Are you married to a Malaysian citizen?",
          options: {
            yes: "Yes",
            no: "No",
          },
        },
        savings: {
          label: "What is your savings / investment capacity?",
          options: {
            under_10k: "Under €10,000",
            "10k_50k": "€10,000 – €50,000",
            "50k_150k": "€50,000 – €150,000",
            over_150k: "Over €150,000",
          },
        },
        family: {
          label: "Who are you moving with?",
          options: {
            alone: "Alone",
            couple: "As a couple",
            with_children: "With children",
          },
        },
      },
      emailGate: {
        title: "Your result is ready!",
        sub: "Enter your email to discover the visa made for you and receive your immigration checklist.",
        placeholder: "Your email address",
        button: "Reveal my visa",
        consent: "No spam. Your data stays confidential.",
        invalid: "Please enter a valid email address.",
        error: "Something went wrong. Please try again.",
      },
      result: {
        heading: "Your recommended visa",
        match: "match",
        requirements: "Key requirements",
        pros: "Strong points",
        alternatives: "Alternatives to consider",
        restart: "Retake the quiz",
        home: "Back to home",
        emailSaved: "Result saved! Check your inbox soon.",
        disclaimerShort:
          "Indicative result — verify official criteria before any application.",
      },
      loading: "Computing your ideal visa...",
      submitError: "Could not compute your result. Please try again.",
      retry: "Retry",
    },
    visas: {
      mm2h: {
        name: "MM2H",
        fullName: "Malaysia My Second Home",
        tagline: "Long-term residency for retirees and comfortable savers",
        forWho: "Retirees, financially independent people, families seeking long-term stay",
        duration: "5 to 20 years, renewable",
        requirements: [
          "Bank deposit from ~USD 150,000 (Silver tier)",
          "Proof of stable financial resources",
          "Health insurance valid in Malaysia",
          "Clean criminal record",
        ],
        pros: [
          "Stable 5-20 year residency",
          "Spouse and children included",
          "Unlimited multiple entries",
        ],
      },
      de_rantau: {
        name: "DE Rantau",
        fullName: "DE Rantau Nomad Pass",
        tagline: "Malaysia's official digital nomad visa",
        forWho: "Remote workers, freelancers and digital nomads with foreign income",
        duration: "12 months, renewable 12 months",
        requirements: [
          "Remote income of at least ~USD 24,000/year",
          "Remote work contract or foreign clients",
          "Valid passport + health insurance",
        ],
        pros: [
          "100% online process via MDEC",
          "Spouse and children can join",
          "Access to DE Rantau hubs nationwide",
        ],
      },
      employment_pass: {
        name: "Employment Pass",
        fullName: "Employment Pass (EP)",
        tagline: "The classic employer-sponsored work visa",
        forWho: "Professionals with a job offer from a Malaysian company",
        duration: "1 to 5 years depending on category",
        requirements: [
          "Job offer from a registered Malaysian company",
          "Minimum salary ~RM 5,000/month (cat. III) to RM 10,000 (cat. I)",
          "Relevant degrees and experience",
        ],
        pros: [
          "Employer-sponsored",
          "Renewable while employed",
          "Family visa available (Dependant Pass)",
        ],
      },
      student_pass: {
        name: "Student Pass",
        fullName: "Student Pass",
        tagline: "Study at Malaysia's international universities",
        forWho: "Students enrolled at a recognized Malaysian institution",
        duration: "Duration of studies",
        requirements: [
          "Admission letter from a recognized institution",
          "Proof of funds for studies + stay",
          "Visa requested via EMGS before arrival",
        ],
        pros: [
          "Very competitive tuition fees",
          "Branch campuses of UK and Australian universities",
          "Part-time work possible (conditions apply)",
        ],
      },
      labuan_investor: {
        name: "Investor / Labuan Visa",
        fullName: "Labuan Director Visa / Investor",
        tagline: "Set up your company and get a 2-year visa",
        forWho: "Entrepreneurs and investors starting a business in Malaysia",
        duration: "2 years, renewable",
        requirements: [
          "Incorporation of a Labuan company (paid-up capital required)",
          "Director position in the company",
          "Financial capacity to invest and sustain the business",
        ],
        pros: [
          "Attractive Labuan taxation (3% or flat)",
          "Visa for spouse and children",
          "Great freedom for international business",
        ],
      },
      spouse_ltsvp: {
        name: "Spouse Visa",
        fullName: "Long-Term Social Visit Pass (spouse)",
        tagline: "For spouses of Malaysian citizens",
        forWho: "People married to a Malaysian citizen",
        duration: "Up to 5 years, renewable",
        requirements: [
          "Marriage certificate recognized in Malaysia",
          "Sponsor: your Malaysian spouse",
          "Evidence of genuine married life",
        ],
        pros: [
          "Work authorization possible (endorsement)",
          "Path towards permanent residence",
          "Increasingly long renewals",
        ],
      },
    },
    admin: {
      title: "Dashboard — Leads",
      sub: "Emails collected via the quiz and the newsletter",
      loginTitle: "Admin area",
      loginSub: "Enter the password to access collected leads.",
      passwordPlaceholder: "Password",
      loginButton: "Log in",
      loginError: "Incorrect password.",
      loginNetworkError: "Could not connect. Try again.",
      logout: "Log out",
      sessionExpired: "Session expired. Please log in again.",
      totalLeads: "Total leads",
      last7: "Last 7 days",
      topVisa: "Top recommended visa",
      quizLeads: "Via quiz",
      newsletterLeads: "Via newsletter",
      export: "Export CSV",
      exportSuccess: "CSV export downloaded.",
      exportError: "Export failed. Try again.",
      colEmail: "Email",
      colDate: "Date",
      colSource: "Source",
      colVisa: "Recommended visa",
      colLang: "Language",
      empty: "No leads yet. Share your page!",
      loading: "Loading leads...",
      error: "Could not load leads.",
      retry: "Retry",
      sourceQuiz: "Quiz",
      sourceNewsletter: "Newsletter",
      none: "—",
    },
    notFound: {
      message: "This page doesn't exist or has been moved.",
      backHome: "Back to home",
    },
    cookieConsent: {
      message: "This site uses cookies to improve your experience and analyze traffic. You can accept or decline.",
      accept: "Accept",
      decline: "Decline",
      ariaLabel: "Cookie consent banner",
    },
  },
};
